import { MantineProvider, localStorageColorSchemeManager } from '@mantine/core';
import { Global } from '@emotion/react';
import { createContext, ReactNode, useContext, useState } from 'react';

type ThemeContextType = {
  colorScheme: 'light' | 'dark' | 'auto';
  toggleColorScheme: () => void;
};

const ThemeContext = createContext<ThemeContextType | null>(null);

// eslint-disable-next-line react-refresh/only-export-components
export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
};

export function ThemeProvider({ children }: { children: ReactNode }) {
  const colorSchemeManager = localStorageColorSchemeManager({
    key: 'autopass-jupiter-color-scheme',
  });

  const [mode, setMode] = useState<'light' | 'dark' | 'auto'>(
    colorSchemeManager.get('light'),
  );

  const toggleColorScheme = () => {
    const newValue = mode === 'dark' ? 'light' : 'dark';
    colorSchemeManager.set(newValue);
    setMode(newValue);
  };

  const isDark = mode === 'dark';

  return (
    <ThemeContext.Provider value={{ colorScheme: mode, toggleColorScheme }}>
      <MantineProvider
        defaultColorScheme={mode}
        forceColorScheme={mode === 'auto' ? 'dark' : mode}
      >
        {/* ✅ 全域背景樣式 */}
        <Global
          styles={{
            body: {
              backgroundColor: isDark ? '#2E2E2E' : '#F8F9FA',
              color: isDark ? '#f1f3f5' : '#212529',
            },
          }}
        />
        {children}
      </MantineProvider>
    </ThemeContext.Provider>
  );
}
